import { render, staticRenderFns } from "./AppData.vue?vue&type=template&id=0a62adb8&scoped=true"
import script from "./AppData.vue?vue&type=script&lang=js"
export * from "./AppData.vue?vue&type=script&lang=js"
import style0 from "./AppData.vue?vue&type=style&index=0&id=0a62adb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a62adb8",
  null
  
)

export default component.exports